import { getIdFromUID, getUserTypeFromUID } from 'app/dataTypes/transfer/uid'
import { Params } from 'app/dataTypes/transfer'

import type { Request } from '../../../../index'


type ParamsApi = {
  sender_id: number
  sender_type: 'Student' | 'Parent'
  recipient_id: number
  recipient_type: 'Student' | 'Parent'
  amount: string
}

export const convertParams = ({ senderUID, recipientUID, amount }: Params): [ParamsApi, null] => {
  return [{
    sender_type: getUserTypeFromUID(senderUID),
    sender_id: getIdFromUID(senderUID),
    recipient_type: getUserTypeFromUID(recipientUID),
    recipient_id: getIdFromUID(recipientUID),
    amount,
  }, null]
}

export const convertResult = () => {
  return true
}

export const POST_TRANSFER: Request<void, boolean, void> = [
  'cabinet/cafeteria/payments/transfer',
  'post',
  ['data'],
]
